import { useEffect, useEffectEvent, useState } from 'react'
import { listMembers } from '../application/manage-members'
import type { ChatMember } from '../domain/chat'
import { chat as chatPort, notify } from '../wiring'

// People picker for starting conversations and managing group membership. Reads
// the chat-owned member lookup; the query is debounced by the caller's input
// cadence (the search runs on each query change).
const useMemberLookup = (query: string | null) => {
	const [members, setMembers] = useState<ChatMember[]>([])

	const search = useEffectEvent(async (q: string | null) => {
		setMembers(await listMembers(chatPort, q, notify))
	})

	useEffect(() => {
		search(query)
	}, [query])

	return members
}

export { useMemberLookup }
